// extracted by mini-css-extract-plugin
export default {"pageTitle":"result_pageTitle__eNyIg","resultWon":"result_resultWon__w+ZCh","resultLost":"result_resultLost__OW2Nh"};